import styled from 'styled-components';
import { Container as BaseContainer } from './CommonStyled';

export const Container = styled(BaseContainer)`
    padding: 20px 0;
`;
